/**
 * `expo-task-manager` no browser: registro de tarefas nomeadas. A execução é feita pelo
 * `@/platform/background-task` (intervalo com a página aberta, evento `online`,
 * mensagens do service worker vindas de Background Sync/Periodic Sync).
 */
type Tarefa = (corpo: { data?: unknown; error?: unknown; executionInfo?: unknown }) => Promise<unknown> | unknown;

const tarefas = new Map<string, Tarefa>();
const registradas = new Set<string>();

export function defineTask(nome: string, fn: Tarefa): void {
  tarefas.set(nome, fn);
}

export function isTaskDefined(nome: string): boolean {
  return tarefas.has(nome);
}

export async function isTaskRegisteredAsync(nome: string): Promise<boolean> {
  return registradas.has(nome);
}

export async function getRegisteredTasksAsync() {
  return Array.from(registradas).map((taskName) => ({ taskName, taskType: "background", options: {} }));
}

export async function unregisterTaskAsync(nome: string) {
  registradas.delete(nome);
}

export async function unregisterAllTasksAsync() {
  registradas.clear();
}

/** @internal usado pelo background-task. */
export function __marcarRegistrada(nome: string, sim: boolean) {
  if (sim) registradas.add(nome);
  else registradas.delete(nome);
}

/** @internal executa a tarefa (nunca lança). */
export async function __executar(nome: string): Promise<unknown> {
  const fn = tarefas.get(nome);
  if (!fn) return undefined;
  try {
    return await fn({ data: undefined, error: undefined, executionInfo: { taskName: nome } });
  } catch (e) {
    console.warn(`[TaskManager] tarefa "${nome}" falhou`, e);
    return undefined;
  }
}

export async function isAvailableAsync() {
  return true;
}
